import * as R from 'ramda'
import { range } from 'lodash-es'

export function buildAxis(options: {
  data?: any[]
  axisType: 'x' | 'y'
  overwriteOption?: any
  type?: echarts.EChartOption.BasicComponents.CartesianAxis.Type
  showLine?: boolean
  showSplitLine?: boolean
  showTick?: boolean
  formatter?: (params) => string
  minValue?: number | string
  maxValue?: number | string
}): echarts.EChartOption.XAxis | echarts.EChartOption.YAxis {
  const isXType = options.axisType === 'x'
  const {
    overwriteOption = {},
    data = null,
    type = isXType ? 'category' : 'value',
    showLine = isXType,
    showSplitLine = false,
    showTick = false,
    formatter = null,
    minValue = type === 'value' ? 0 : null,
    maxValue = type === 'value' ? 100 : null,
  } = options
  return R.mergeDeepRight(
    {
      data,
      type,
      // splitNumber: 1,
      axisLine: {
        show: showLine,
        lineStyle: {
          color: 'rgba(6, 64, 80, 0.3)', // 0f45cd
          width: 2,
        },
      },
      axisTick: {
        show: showTick,
        alignWithLabel: false,
      },
      splitLine: { show: showSplitLine },
      axisLabel: {
        show: !!formatter,
        showMinLabel: true,
        showMaxLabel: true,
        interval: data ? data.length - 1 : null,
        formatter: formatter,
      },
      min: minValue,
      max: maxValue,
    },
    overwriteOption
  )
}

export function getMarkLineRange({
  minStart = 2,
  minStep = 2,
  minEnd = 0,
  maxYValue = 10,
  numOfSeparate = 5,
  ceilSeparateNum = false,
}: {
  minStart?: number
  minStep?: number
  minEnd?: number
  maxYValue: number
  numOfSeparate?: number
  ceilSeparateNum?: boolean
}): number[] {
  const separateCounts = ceilSeparateNum ? Math.ceil(maxYValue / numOfSeparate) : Math.floor(maxYValue / numOfSeparate)
  const step = Math.max(minStep, separateCounts)
  const startNum = Math.max(0, step)
  const endNum = Math.max(minEnd, maxYValue) + 1
  return range(startNum, endNum, step)
}

export function buildMarkLine(points: number[]) {
  return {
    silent: true,
    precision: 0,
    symbol: [],
    label: {
      position: 'start',
      formatter: params => {
        const data = params.value
        if (!Number.isInteger(data)) {
          return data
        }
        if (data >= 1000) {
          return `${data * 0.001}k`
        } else {
          return data
        }
      },
    },
    lineStyle: {
      color: '#0f45cd',
      opacity: 0.2,
      type: 'solid',
    },
    data: points.map(num => ({ yAxis: num })),
  }
}
